import React from 'react';
import type { IconProps } from '../types';

export const IconTrash: React.FC<IconProps> = ({ size = 20, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M3 5H17" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M8 3H12" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M15 5V16C15 16.5523 14.5523 17 14 17H6C5.44772 17 5 16.5523 5 16V5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 9V13" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M12 9V13" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);
